import {Component,Inject,OnInit} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {CollabListItemComponent} from "./collab-list-item.component";
import {ListView,TypeComparaison} from "@domain/common/list-view";
import {UserDto} from "@domain/user/user-dto";
import {MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA} from "@angular/material/legacy-dialog";
import {TypePortee} from "@domain/workflow/workflow";
import {HttpParams} from "@angular/common/http";

/**
 * Composant d'affichage d'une liste de collaborateurs en vue de la création d'un objet workflow.
 */
@Component({
    templateUrl: './collab-list.component.html',
    host: {'data-test-id': 'collab-list'}
})
export class CollabListComponent implements OnInit {
    /** Liste des collaborateurs */
    liste: ListView<UserDto, CollabListItemComponent>;

    /**
     * Constructeur
     */
    constructor(private translateService: TranslateService,
                @Inject(MAT_DIALOG_DATA) private data: { portee: TypePortee, purpose: CollabListComponent.Purpose }) {
    }

    /**
     * Initialisation du composant
     */
    ngOnInit() {
        //URL utilisée pour générer la liste
        let url: string;

        //Si la destination de la fenêtre est de créer un objet WF
        if (this.data.purpose == CollabListComponent.Purpose.CREATION_OBJET_WF_FOR_COLLAB) {
            //Construction des paramètres à envoyer pour la récupération de la liste des collaborateurs en fonction de la portée de l'objet à créer
            const params = new HttpParams().append("portee",this.data.portee);

            //Affectation de l'URL sur la création des objets
            url = "listeCollabPourCreation?" + params.toString();
        } else if (this.data.purpose == CollabListComponent.Purpose.SEE_CARD_OPERATIONS_FOR_COLLAB) {
            //Sinon, si la destination de la fenêtre est de visualiser les frais cartes, alors affectation de l'URL sur la visualisation des opérations cartes
            url = "listeCollabPourOpeCarte";
        } else {
            //Sinon, génération d'une erreur
            throw new Error("Une destination doit être fournie pour la construction du composant");
        }

        //Définition de la liste
        this.liste = new ListView<UserDto, CollabListItemComponent>({
            uri: `/controller/User/${url}`,
            title: this.translateService.instant('workflow.selectionCollab.liste.title'),
            isLocal: true,
            isFilter: true,
            component: CollabListItemComponent,
            listeFilters: [{
                title: this.translateService.instant('filter.prenom'),
                clef: 'prenom',
                typeComparaison: TypeComparaison[TypeComparaison.LIKE],
                isDefault: true
            }, {
                title: this.translateService.instant('filter.nom'),
                clef: 'nom',
                typeComparaison: TypeComparaison[TypeComparaison.LIKE],
                isDefault: true
            }, {
                title: this.translateService.instant('filter.matricule'),
                clef: 'matricule',
                typeComparaison: TypeComparaison[TypeComparaison.EQUAL],
                isDefault: true
            }, {
                title: this.translateService.instant('filter.service'),
                clef: 'orga.libelle',
                typeComparaison: TypeComparaison[TypeComparaison.LIKE],
                isDefault: false
            }]
        });
    }
}

/**
 * Namespace du même nom que le composant
 */
export namespace CollabListComponent {
    /**
     * Enum dédié à la destination du composant (il peut servir à afficher des listes de collaborateurs pour plusieurs choses)
     */
    export enum Purpose {
        CREATION_OBJET_WF_FOR_COLLAB = 0,
        SEE_CARD_OPERATIONS_FOR_COLLAB = 1
    }
}
